import Investors from './Investors';

export default Investors;
